// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

// Custom JavaScript for Kasmu theme
// Bootstrap is loaded separately via Gulp

document.addEventListener('DOMContentLoaded', function() {
  // Initialize tooltips
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

  // Simple mobile menu toggle
  const navbarToggler = document.querySelector('.navbar-toggler');
  if (navbarToggler) {
    navbarToggler.addEventListener('click', function() {
      const collapseElement = document.querySelector('.collapse:not(.show)');
      if (collapseElement) {
        collapseElement.style.display = collapseElement.style.display === 'block' ? 'none' : 'block';
      }
    });
  }

  console.log('Kasmu theme loaded');
});
